import React from 'react'
import { Bar } from 'react-chartjs-2'
import { ChartOptions } from 'chart.js'

interface BarChartProps {
  chartData: any
  chartOptions?: ChartOptions<'bar'>
  height?: number
}

const BarChart: React.FC<BarChartProps> = (props) => {
  return (
    <Bar
      data={props.chartData}
      options={props.chartOptions}
      height={props.height || 150}
    />
  )
}
export default BarChart
